module.exports = __webpack_public_path__ + "img/logo.e9dc6603.png";